<template>
  <div class="main-content">
      <el-form ref="form" :model="form" >
        <el-form-item label="" prop="endDate">
          <div class="pxy-tag-label">
            <span>开始时间：</span>
          </div>
          <el-date-picker
            v-model="form.startDate"
            value-format="yyyy-MM-dd HH:mm:ss"
            align="right"
            type="datetime"
            placeholder="选择日期">
          </el-date-picker>
          <el-tooltip effect="light" placement="top-start">
            <p slot="content" class="tip-info" style="max-width: 900px">新授权码的开始时间。 </p>
            <i class="el-icon-question tip-icon"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="" prop="endDate">
          <div class="pxy-tag-label">
            <span>结束日期：</span>
          </div>
          <el-date-picker
            v-model="form.endDate"
            value-format="yyyy-MM-dd HH:mm:ss"
            align="right"
            type="datetime"
            :picker-options="{
              disabledDate(time) {
                if (!form.startDate) {
                  return false;
                }
                const start = new Date(form.startDate).getTime();
                const max = new Date(start);
                max.setMonth(max.getMonth() + 6);
                return time.getTime() < start || time.getTime() > max.getTime();
              }
            }"
            placeholder="选择日期">
          </el-date-picker>
          <el-tooltip effect="light" placement="top-start">
            <p slot="content" class="tip-info" style="max-width: 900px">新授权码的结束时间。 </p>
            <i class="el-icon-question tip-icon"></i>
          </el-tooltip>
        </el-form-item>
      </el-form>

        <div  class="item" style="">
          <el-button type="primary" class="pxy-primary" plain @click="updateSn()">确认</el-button>
        </div>
    </div>

</template>

<script>
  import {Message} from "element-ui";
  export default {
    components: {},
    data() {
      return {
        sn: this.$route.query.sn,

        form:{
          startDate:new Date(),
          endDate:''
        }
      }
    },
    created() {
    },
    methods: {
      updateSn: function () {
        var params = {};
        params.sn = this.sn;
        if(this.form.startDate){
          params.startDate = new Date(this.form.startDate).getTime();
        }
        if(this.form.endDate){
          params.endDate = new Date(this.form.endDate).getTime();
        }
        this.$refs["form"].validate((valid) => {
          if (valid) {
            var that = this;
            this.$confirm('更新授权信息后，将会重新生成一个授权码， 请将新的授权码拷贝给客户使用。', '温馨提示', {
              confirmButtonText: '更新',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }).then(() => {
              that.doUpdate(params);
            }).catch(() => {

            });

          }
        })
      },
      doUpdate:function(params){
        this.loading = true;
        this.postRequestJson('/localSn/renew', JSON.stringify(params)).then(resp => {
          this.loading = false;
          if (resp && resp.status == 200) {
            var data = resp.data;
            if (data.code == 1000) {
              var query = {}
              if(this.$route.query.mid){
                query.mid = this.$route.query.mid
              }
              /*if(this.$route.query.customerId){
                query.customerId = this.$route.query.customerId
              }*/
              this.$router.replace({path: '/localSn/index', query: query});
            } else {
              Message.error(data.message);
            }
          }
        });
      },
    }
    ,
    mounted: function () {
      // 获取当前日期和时间
      var endDate = new Date();

// 将当前日期增加一个月
      endDate.setMonth(endDate.getMonth() + 1);
      this.form.endDate = endDate;
    }
    ,
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    beforeDestroy() {

    }
  }
</script>
<style scoped>
.sn-content .pxy-form-item .el-checkbox{
  float: none;
}
.box-card {
  text-align: left;
    border: 1px solid #EBEEF5;
    background-color: #FFF;
    color: #303133;
    border-radius: 4px;
    /* padding: 20px; */

}
@media screen and (max-width: 768px) {
  /* 1px solid #EBEEF5 */
  .pxy-form-item .el-form-item__content .el-tag {
    height: auto!important;
    white-space: normal!important;
  }
  .pxy-form-item {
    margin-bottom: 10px!important;
    padding-bottom: 15px!important;
    box-sizing: border-box!important;
  }
  .pxy-form-item-line {
    border-bottom: 1px solid #EBEEF5!important;
  }
}

@media screen and (min-width: 769px) {
  .pxy-form-item .el-form-item__content {
    margin-left: 0!important;
  }
  .pxy-form-item .el-form-item__content .el-tag {
    margin-left: 10px!important;
  }
  .pxy-tag-label {
    display: inline-block;
  }
}
</style>
